import React from 'react'
import { PrismicRichText } from '@prismicio/react'

import ContactForm from './forms/contactForm'

const Contact = ({ slice, treatyItem, wantedItem }) => {
  return (
    <section className='component-contact mx-auto w-full max-w-screen-xl p-6'>
      <div className='grid md:gap-6 md:grid-cols-5'>
        {slice.primary.text.text && (
          <div className='prose prose-lg md:col-span-2 max-w-screen-2xl pb-8 lg:pr-16'>
            <PrismicRichText field={slice.primary.text.richText} />
          </div>
        )}
        <div className='flex items-start md:col-span-3 relative z-10'>
          <span className='sticky top-0 w-full border'>
            <ContactForm treatyItem={treatyItem} wantedItem={wantedItem} />
          </span>
        </div>
      </div>
    </section>
  )
}

export default Contact
